import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import MainLayout from './components/MainLayout';
import LoginPage from './pages/LoginPage';
import BalanceChart from './components/BalanceChart';

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          {user ? <Redirect to="/balance" /> : <LoginPage />}
        </Route>
        <Route path="/balance">
          {user ? (
            <MainLayout>
              <BalanceChart />
            </MainLayout>
          ) : (
            <Redirect to="/" />
          )}
        </Route>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
